export default "__VITE_ASSET__CbuxzVX$__"